import { formatFixed } from "./numberFormat";

export const METERS_PER_NM = 1852;
export const KM_PER_NM = 1.852;

function adaptiveDigits(value: number): number {
  return value >= 100 ? 0 : value >= 10 ? 1 : 2;
}

export function knotsToKmh(knots: number): number {
  return knots * KM_PER_NM;
}

export function kmhToKnots(kmh: number): number {
  return kmh / KM_PER_NM;
}

export function nmToKm(nm: number): number {
  return nm * KM_PER_NM;
}

export function kmToNm(km: number): number {
  return km / KM_PER_NM;
}

export function formatDistance(
  meters: number,
  locale: string,
  useSiUnits: boolean,
): string {
  if (useSiUnits) {
    const km = meters / 1000;
    return `${formatFixed(km, locale, adaptiveDigits(km))} km`;
  }
  const nm = meters / METERS_PER_NM;
  return `${formatFixed(nm, locale, adaptiveDigits(nm))} nm`;
}

export function formatSpeedFromKnots(
  knots: number,
  locale: string,
  useSiUnits: boolean,
  digits = 1,
): string {
  if (useSiUnits) {
    return `${formatFixed(knotsToKmh(knots), locale, digits)} km/h`;
  }
  return `${formatFixed(knots, locale, digits)} kn`;
}

export function speedUnitLabel(useSiUnits: boolean): string {
  return useSiUnits ? "km/h" : "kn";
}

export function distanceUnitLabel(useSiUnits: boolean): string {
  return useSiUnits ? "km" : "nm";
}

/** MapLibre expression for AIS SOG label (sog stored in knots). */
export function aisSogTextFieldExpression(useSiUnits: boolean) {
  if (useSiUnits) {
    return [
      "concat",
      ["get", "name"],
      "\n",
      // One decimal place: round(sog * 1.852 * 10) / 10
      [
        "to-string",
        ["/", ["round", ["*", ["get", "sog"], KM_PER_NM * 10]], 10],
      ],
      " km/h",
    ];
  }
  return ["concat", ["get", "name"], "\n", ["get", "sog"], " kn"];
}
